
/* eslint no-underscore-dangle:  0 */
/* eslint-disable no-debugger, no-console */
/* eslint-disable */
const { CREATE_TRANSACTION_FAILURE } = require("Redux/types/transaction")
const { GET_TRANSACTION_SUCCESS } = require("Redux/types/transaction")
const { UPDATE_TRANSACTION_REQUEST } = require("Redux/types/transaction")
const { UPDATE_TRANSACTION_FAILURE } = require("Redux/types/transaction")
const { DELETE_TRANSACTION_SUCCESS } = require("Redux/types/transaction")
const { GET_ALL_TRANSACTION_REQUEST } = require("Redux/types/transaction")
const { GET_ALL_TRANSACTION_FAILURE } = require("Redux/types/transaction")
const { GET_ALL_TRANSACTION_SUCCESS } = require("Redux/types/transaction")
const { DELETE_TRANSACTION_FAILURE } = require("Redux/types/transaction")
const { DELETE_TRANSACTION_REQUEST } = require("Redux/types/transaction")
const { UPDATE_TRANSACTION_SUCCESS } = require("Redux/types/transaction")
const { GET_TRANSACTION_FAILURE } = require("Redux/types/transaction")
const { GET_TRANSACTION_REQUEST } = require("Redux/types/transaction")
const { CREATE_TRANSACTION_SUCCESS } = require("Redux/types/transaction")
const { CREATE_TRANSACTION_REQUEST } = require("Redux/types/transaction")


const initialState={
    transaction:null,
    transactions:null,
    loading:false,
    success:false,
    error:null,
}
const transaction=(state=initialState,action)=>{
    switch(action.type){
        case CREATE_TRANSACTION_REQUEST:
            return{
                ...state,
                loading:true,
            }
        case CREATE_TRANSACTION_SUCCESS:
            return{
                ...state,
                loading:false,
                success:true,
                transaction:action.payload,
                error:null,
            }
        case CREATE_TRANSACTION_FAILURE:
            return{
                ...state,
                loading:false,
                error:action.payload,
                success:false,
                transaction:action.payload,
            }
        case GET_TRANSACTION_REQUEST:
            return{
                ...state,
                loading:true,
            }
        case GET_TRANSACTION_SUCCESS:
            return{
                ...state,
                loading:false,
                success:true,
                transaction:action.payload,
                error:null,
            }
        case GET_TRANSACTION_FAILURE:
            return{
                ...state,
                loading:false,
                error:action.payload,
                success:false,

            }
        case GET_ALL_TRANSACTION_REQUEST:
            return{
                ...state,
                loading:true,
            }
        case GET_ALL_TRANSACTION_SUCCESS:
            return{
                ...state,
                loading:false,
                success:true,
                transactions:action.payload,
                error:null,
            }
        case GET_ALL_TRANSACTION_FAILURE:
            return{
                ...state,
                loading:false,
                error:action.payload,
                success:false,

            }
        case UPDATE_TRANSACTION_REQUEST:
            return{
                ...state,
                loading:true,
            }
        case UPDATE_TRANSACTION_SUCCESS:
            return{
                ...state,
                loading:false,
                success:true,
                transaction:action.payload,
                error:null,
            }
        case UPDATE_TRANSACTION_FAILURE:
            return{
                ...state,
                loading:false,
                error:action.payload,
                success:false,

            }
        case DELETE_TRANSACTION_REQUEST:
            return{
                ...state,
                loading:true,
            }
        case DELETE_TRANSACTION_SUCCESS:
            return{
                ...state,
                loading:false,
                success:true,
                transaction:action.payload,
                error:null,
            }
        case DELETE_TRANSACTION_FAILURE:
            return{
                ...state,
                loading:false,
                error:action.payload,
                success:false,

            }

        default:
            return state;
    }
}
export default transaction;
